<div class="modal-header">
    <h4 class="modal-title">New Report</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="form-group">
            <label for="name">Name</label>
            <input type="text" class="form-control" id="name" formControlName="name"
                [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
            @if (submitted && f.name.errors) {
            <div class="invalid-feedback">
                @if (f.name.errors.required) {
                <div>Name is required</div>
                }
            </div>
            }
        </div>
        <div class="form-group">
            <label for="view_name">View Name</label>
            <input type="text" class="form-control" id="view_name" formControlName="view_name"
                [ngClass]="{ 'is-invalid': submitted && f.view_name.errors }">
            @if (submitted && f.view_name.errors) {
            <div class="invalid-feedback">
                @if (f.view_name.errors.required) {
                <div>View Name is required</div>
                }
            </div>
            }
        </div>
        <div class="form-group">
            <label for="config">Config (JSON)</label>
            <textarea class="form-control" id="config" rows="5" formControlName="config"
                [ngClass]="{ 'is-invalid': submitted && f.config.errors }"></textarea>
            @if (submitted && f.config.errors) {
            <div class="invalid-feedback">
                @if (f.config.errors.required) {
                <div>Config is required</div>
                }
                @if (f.config.errors.invalidJson) {
                <div>Invalid JSON</div>
                }
            </div>
            }
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('Close click')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="submit()">Save</button>
</div>